import app from '@/js/app.js';
import LANGUAGES_LIST from '@/js/const/languagesList.js';

const validate = code => {
  return LANGUAGES_LIST[code] !== undefined;
};

const getFullLangugeName = code => {
  return validate(code) ? LANGUAGES_LIST[code].nativeName : null;
};

const getPreferredLanguage = (f7, cb) => {
  const lang = (navigator.language || navigator.userLanguage).split('-')
    ? (navigator.language || navigator.userLanguage).split('-')[0]
    : navigator.language || navigator.userLanguage;
  cb(lang);
};

const setUserLanguageToLocalStorage = (name, val) => {
  localStorage.setItem(name, val);
};

const getUserLanguageFromLocalStorage = cb => {
  localStorage.getItem('lang')
    ? cb(localStorage.getItem('lang'))
    : cb(localStorage.getItem('nativeLang'));
};

const setLangsToLocalStorage = langs => {
  localStorage.setItem('langs', JSON.stringify(langs));
};

const setI18nLocale = lang => {
  app.$i18n.locale = lang;
};

const setLangsToI18n = langs => {
  for (let [key, val] of Object.entries(langs)) {
    app.$i18n.setLocaleMessage(key, val);
  }
};

export {
  getFullLangugeName,
  getPreferredLanguage,
  setUserLanguageToLocalStorage,
  getUserLanguageFromLocalStorage,
  setLangsToLocalStorage,
  setI18nLocale,
  setLangsToI18n
};
